import './axios.config';
import { common } from '@demo/services/common';
import { article } from './article';
import { user } from './user';
import { template } from './template';

const services = {
  common,
  article,
  user,
  template,
};

export default services;
